import { defineRecipe as r } from "@pandacss/dev";
import { typeFacePrimitives as e, buttonRecipe as a } from "@huspy/briks-core";
import "../../node_modules/lodash/lodash.mjs";
import { pixify as i } from "../../utils/transform.mjs";
const o = r({
  className: "button",
  base: {
    p: "5",
    transition: "0.3s",
    position: "relative",
    fontFamily: e["sans-serif"],
    borderRadius: "3",
    _hover: a.hover,
    "& svg": {
      width: "unset!",
      height: "unset!"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "md",
    loading: !1
  },
  variants: {
    size: i(a.size),
    variant: a.variant,
    disabled: { true: { pointerEvents: "none" } },
    rounded: a.rounded,
    loading: { true: { pointerEvents: "none" } }
  },
  compoundVariants: [
    {
      variant: "primary",
      css: {
        _hover: a.hover.primary,
        _active: a.active.primary
      }
    },
    {
      variant: "secondary",
      css: {
        _hover: a.hover.secondary,
        _active: a.active.secondary
      }
    },
    {
      variant: "tertiary",
      css: {
        _hover: a.hover.tertiary,
        _active: a.active.tertiary
      }
    },
    {
      variant: "quaternary",
      css: {
        _hover: a.hover.quaternary,
        _active: a.active.quaternary
      }
    },
    {
      variant: "primary",
      disabled: !0,
      css: {
        ...a.disabled.primary,
        _hover: {
          ...a.disabled.primary
        },
        _active: {
          ...a.disabled.primary
        }
      }
    },
    {
      variant: "secondary",
      disabled: !0,
      css: {
        ...a.disabled.secondary,
        _hover: {
          ...a.disabled.secondary
        },
        _active: {
          ...a.disabled.secondary
        }
      }
    },
    {
      variant: "tertiary",
      disabled: !0,
      css: {
        ...a.disabled.tertiary,
        _hover: {
          ...a.disabled.tertiary
        },
        _active: {
          ...a.disabled.tertiary
        }
      }
    },
    {
      variant: "quaternary",
      disabled: !0,
      css: {
        ...a.disabled.quaternary,
        _hover: {
          ...a.disabled.quaternary
        },
        _active: {
          ...a.disabled.quaternary
        }
      }
    },
    {
      loading: !0,
      variant: "primary",
      css: {
        ...a.loading.primary,
        _hover: {
          ...a.loading.primary
        },
        _active: {
          ...a.loading.primary
        }
      }
    },
    {
      loading: !0,
      variant: "secondary",
      css: {
        ...a.loading.secondary,
        _hover: {
          ...a.loading.secondary
        },
        _active: {
          ...a.loading.secondary
        }
      }
    },
    {
      loading: !0,
      variant: "tertiary",
      css: {
        ...a.loading.tertiary,
        _hover: {
          ...a.loading.tertiary
        },
        _active: {
          ...a.loading.tertiary
        }
      }
    },
    {
      loading: !0,
      variant: "quaternary",
      css: {
        ...a.loading.quaternary,
        _hover: {
          ...a.loading.quaternary
        },
        _active: {
          ...a.loading.quaternary
        }
      }
    }
  ]
});
export {
  o as button
};
